module.exports = __webpack_public_path__ + "img/level-3.8cc83b21.png";